export const initSelect = function() {
  //   ChoicesSelect.Start
  const selectChoicesAll = document.querySelectorAll('[data-select-choices] select');

  if (selectChoicesAll.length > 0) {
    selectChoicesAll.forEach((item) => {
      const select = new Choices(item, {
        allowHTML: true,
        searchEnabled: false,
        shouldSort: false,
        itemSelectText: 'Выбрать',
        resetScrollPosition: false
        // classNames: {
        //   highlightedState: 'is-hover',
        // },
      });
      select.enable();
    });
  }
  //   ChoicesSelect.End

  //   CustomChoicesSelect.Start
  const selectPopular = document.querySelectorAll('[data-custom-choices] select');
  if (selectPopular.length > 0) {
    selectPopular.forEach((item) => {
      const select = new Choices(item, {
        noResultsText: 'Ничего не найдено',
        allowHTML: true,
        searchEnabled: false,
        selectedState: 'is-selected',
        shouldSort: false,
        resetScrollPosition: false,
        classNames: {
          highlightedState: 'is-hover'
        },
        callbackOnCreateTemplates: function(template) {
          return {
            item: ({ classNames }, data) => {
              return template(`
          <div class="${classNames.item} ${data.highlighted ? classNames.highlightedState : classNames.itemSelectable} ${data.placeholder ? classNames.placeholder : ''}" data-item data-id="${data.id}" data-value="${data.value}" data-select-setting="${data.customProperties}" ${data.active ? 'aria-selected="true"' : ''} ${data.disabled ? 'aria-disabled="true"' : ''}> ${data.label}
          </div>
        `);
            },
            choice: ({ classNames }, data) => {
              return template(`
          <div class="${classNames.item} ${classNames.itemChoice} ${data.selected ? classNames.selectedState : ''} ${data.disabled ? classNames.itemDisabled : classNames.itemSelectable}" data-select-text="${this.config.itemSelectText}" data-choice ${data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable'} data-id="${data.id}" data-value="${data.value}" data-select-setting="${data.customProperties}" ${data.groupId > 0 ? 'role="treeitem"' : 'role="option"'}> ${data.label}
          </div>
        `);
            }
          };
        }
      });
      select.enable();
    });
  }

  //   CustomChoicesSelect.End
};
